import React from "react";
import { v4 as uuidv4 } from "uuid";
import MainLayout, { MobileMenu } from "./MainLayout";
import { Box, Grid } from "@mui/material";
import { History, Stars, SvgIconComponent } from "@mui/icons-material";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { LocalAtm } from "@mui/icons-material";
import PaidIcon from "@mui/icons-material/Paid";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import { NavLink } from "react-router-dom";
export const sidebar: ISidebar = {
  links: [
    {
      icon: <HomeWorkIcon />,
      link: "/dashboard",
      label: "Overview",
    },

    {
      icon: <PaidIcon />,
      link: "/topup",
      label: "Top Up",
    },
    {
      icon: <LocalAtm />,
      link: "/Redemptions",
      label: "Redemptions",
    },
    {
      icon: <History />,
      link: "/transactions",
      label: "Transactions",
    },
    {
      icon: <Stars />,
      link: "/referral",
      label: "Rewards",
    },
    {
      icon: <ProductionQuantityLimitsIcon />,
      link: "/products",
      label: "Products",
    },
  ],
};
function AuthenticatedLayout(props: IWrapper) {
  return (
    <MainLayout showHamburger>
      <Grid container xs={12}>
        <Grid item xs={0} lg={2} display={{ xs: "none", md: "block" }}>
          <Sidebar links={sidebar.links} />
        </Grid>

        <Grid
          item
          xs={12}
          md={9.9}
          bgcolor="#eef2f6"
          borderRadius={5}
          p={3}
          // mr={0.4}
          minHeight={"80vh"}
        >
          {props.children}
        </Grid>
      </Grid>
    </MainLayout>
  );
}

interface ISidebar {
  // todo : get the correct type for icon
  links: { link: string; icon: any | SvgIconComponent; label: string }[];
}
function Sidebar(props: ISidebar) {
  return (
    <Box
      mt={-2}
      pt={6}
      sx={{
        bgcolor: "white",
        height: "100%",
        minHeight: "calc(100vh - 50px)",
      }}
    >
      {props.links.map(({ icon, link, label }) => (
        <NavLink to={link}>
          {({ isActive }) => (
            <Box
              key={uuidv4()}
              sx={{
                gap: "10px",
                display: "flex",
                alignItems: "center",
                mb: 2,
                "& :hover": {
                  backgroundColor: "red",
                },
              }}
              p={1}
              fontWeight={600}
              bgcolor={isActive ? "rgba(93,38,132,0.1)" : "transparent"}
              m={2}
              borderRadius={2}
              fontSize={14}
              color={isActive ? "rgba(93,38,132,1)" : "rgba(93,38,132,0.8)"}
            >
              {icon}
              {label}
            </Box>
          )}
        </NavLink>
      ))}
    </Box>
  );
}
export default AuthenticatedLayout;
